<div class="container">
  <div >
    <mat-accordion>
      @for (project of prospectDeals; track project) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="row-check">
                <mat-checkbox [value]="project.id"></mat-checkbox>
              </div>
              <div class="row-check">{{project.name}}</div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>This is the primary content of the panel.</p>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="save-row">
    <button mat-raised-button>ADD</button>
  </div>
</div>
